export default __webpack_public_path__ + "static/media/iot_icon.cd27bef4.svg";